import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Home from './Home/Home';
import About from './About/About';
import Contact from './Contact/Contact';
import Services from './Services/Services';
import Footer from './Footer/Footer';
import SignIn from './SignIn/SignIn';
import WelcomeMessage from './Welcome/WelcomeMessage';
import '../App.css'

const App = () => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState('all');
    const [sortBy, setSortBy] = useState('sort by');
    const [isDarkMode, setDarkMode] = useState(false);
    const [showPage, setShowPage] = useState(false); 
    const [authenticated, setAuthenticated] = useState(false);
    const darkmodeClass = ` ${isDarkMode ? 'dark-mode' : ''}`;

    const clearFilters = () => {
        setSearch('');
        setFilter('all');
        setSortBy('sort by');
    };

    const handleSignInClick = () => {
        // Logic for signing in (e.g., showing a sign-in modal)
        console.log("Navigate to SignIn");
      };
    
      const handleSignOutClick = () => {
        // Logic for signing out
        console.log("Navigate to Signout");
      };

      useEffect(() => {
       const delayToShowPage = setTimeout(() => {
            setShowPage(true);
        }, 5000);

        return () => clearTimeout(delayToShowPage);
    }, []);

    return (
        <>
        {showPage ? (
            <Router>
                <Navbar className='navbar' darkmodeClass={darkmodeClass} isDarkMode={isDarkMode} setDarkMode={setDarkMode} clearFilters={clearFilters}   onSignInClick={handleSignInClick} onSignOutClick={handleSignOutClick} authenticated={authenticated} setAuthenticated={setAuthenticated}/>
                <Routes>
                    <Route path="/" element={authenticated ? (<Home darkmodeClass={darkmodeClass} data={data} />) : (<SignIn darkmodeClass={darkmodeClass} setAuthenticated={setAuthenticated}  />)}/>
                    <Route path="/about" element={authenticated ? (<About darkmodeClass={darkmodeClass}/>) : (<SignIn darkmodeClass={darkmodeClass} setAuthenticated={setAuthenticated}  />)}/>
                    <Route path="/contact" element={authenticated ? (<Contact darkmodeClass={darkmodeClass} />) : (<SignIn darkmodeClass={darkmodeClass} setAuthenticated={setAuthenticated}  />)}/>
                    <Route path="/services" element={authenticated ? (<Services darkmodeClass={darkmodeClass} />) : (<SignIn darkmodeClass={darkmodeClass} setAuthenticated={setAuthenticated}  />)}/>
                    <Route path="/signin" element={<SignIn darkmodeClass={darkmodeClass} setAuthenticated={setAuthenticated} />} />
                </Routes>

                {authenticated && <Footer darkmodeClass={darkmodeClass} clearFilters={clearFilters}/>}
            </Router>
             ) : (
                <WelcomeMessage />
            )}
        </>
    );
};

export default App;
